// extracted by mini-css-extract-plugin
export default {"infoIcon":"UserSelectionBase_infoIcon__MWGvX"};